import { render, staticRenderFns } from "./col-sorter.vue?vue&type=template&id=74a14968&scoped=true&"
import script from "./col-sorter.vue?vue&type=script&lang=js&"
export * from "./col-sorter.vue?vue&type=script&lang=js&"
import style0 from "./col-sorter.vue?vue&type=style&index=0&id=74a14968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a14968",
  null
  
)

export default component.exports